import { useEffect } from 'react';
import hash from 'object-hash';

import PAGES from '@/constants/pages';
import { useAppDispatch, useAppSelector } from '@/features/hooks';
import { rootActions, rootQueriesApi, rootSelectors } from '@/features/store';
import useAppFetch from '@/hooks/useAppFetch';
import useCurrentPage from '@/hooks/useCurrentPage';

const POLLING_INTERVAL = 60_000 * 5;

const useComparisonActualize = () => {
  const dispatch = useAppDispatch();

  const currentPage = useCurrentPage();

  const comparisonIds = useAppSelector(state =>
    rootSelectors.comparison.selectIds(state.comparison),
  );
  const parameters = useAppSelector(rootSelectors.comparison.actualParametersSelector);

  const [fetchCars, queryResult] = rootQueriesApi.cars.useLazyGetCarsQuery({
    pollingInterval: POLLING_INTERVAL,
    refetchOnFocus: true,
  });

  useAppFetch(
    async () => {
      if (currentPage !== PAGES.Comparison) {
        await fetchCars(parameters).unwrap();
      }
    },
    [parameters],
    { ssr: hash(parameters), skip: !comparisonIds.length },
  );

  useAppFetch(
    async () => {
      if (currentPage === PAGES.Comparison) {
        await fetchCars(parameters).unwrap();
      }
    },
    [parameters, currentPage],
    { ssr: hash(parameters), skip: !comparisonIds.length },
  );

  useEffect(() => {
    if (!queryResult.data) {
      return;
    }

    const currentIds = queryResult.data.items.map(item => item.id);

    dispatch(rootActions.comparison.actualizeItems(currentIds));
  }, [dispatch, queryResult.data]);

  return queryResult;
};

export default useComparisonActualize;
